import { Component, OnInit, ElementRef, ViewChild, Input, EventEmitter, HostListener, Renderer2, ChangeDetectorRef, AfterViewInit } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'home-prepopular',
  templateUrl: '../sharedTemplates/home-prepopular.component.html',
})
export class HomePrePopularComponent implements AfterViewInit {
  preMatchList = [];
  preMatchobservable = new BehaviorSubject<any>([]);
  favPreMatchobservable = new BehaviorSubject<any>([]);
  _selectedOdds: OddModel[] = [];
  _catId = '0';
  oddMarketingValue = [0];

  contentHeight;
  othersHeight;

  @HostListener('window:resize', ['$event'])
  onResize() {
    // used windopw-innerWidth   this._UiHelper.setResolution(window.innerWidth,window.innerHeight);
  }

  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    private _DataHelper: DataHelper,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    public _LZ: LocalizationService,
    private cdRef: ChangeDetectorRef,
    private _SignalRService: SignalrServiceLegacy
  ) {}
  ngAfterViewInit() {
    this.getGetPopularFixture('-1');

    //Daha önce seçilen oddları tekrar seçsin
    this._ApiService.selectedOddsEvent.subscribe(x => {
      this._selectedOdds = x as OddModel[];
    });
    this._ApiService.getSelectedOdds();
  }
  oddMarketingChange(e) {
    this.oddMarketingValue[0] = e;

    // Favorable states Updates
    const x = this.getFavorableStates(this.preMatchList);
    this.preMatchList = x;
    this.preMatchobservable.next(this.preMatchList);
    //////console.log('E', e);
    //this.cdRef.detectChanges();
  }
  getGetPopularFixture(_sId) {
    this._ApiService
      .getFixture('-1', '17')
      .then(x => {
        this.preMatchList = x;
        //////console.log('prematch', 'data');
        this.preMatchobservable.next(this.preMatchList);
        //this.changeSearch(false);
      })
      .catch(err => console.log('home-prepopular', err));
  }

  heightsetter(c) {
    this.contentHeight = c - this.othersHeight;
    this.contentHeight += 'px';
    ////console.log(this.contentHeight);
  }

  getFavorableStates(_x) {
    const a = this._UserHelper.favoriedMatches;
    return _x.map(y => {
      // ////console.log(a, y.BetradarMatchId);
      if (a == null) {
        return y;
      }
      if (a.includes(y.BetradarMatchId)) {
        y['favorableState'] = true;
        return y;
      } else {
        y['favorableState'] = false;
        return y;
      }
    });
  }

  getGetFixture() {
    this._ApiService.getFixture().then(x => {
      x = this.getFavorableStates(x);
      this.preMatchList = x;
      // ////console.log('prematch', x);
      this.preMatchobservable.next(this.preMatchList);
      //this.changesearch(false);
      this.cdRef.detectChanges();
    });
  }
  getFavs() {
    this._ApiService.getSearch4Favs().then(x => {
      x = this.getFavorableStates(x);
      this.favPreMatchobservable.next(x);
      this.cdRef.detectChanges();
    });
  }
}
export class OddModel {
  constructor(OddId: number) {
    this.OddId = OddId;
  }

  OddId: number;
}
